import { render } from "./HomeCirculars.vue?vue&type=template&id=70f24ddd"
import script from "./HomeCirculars.vue?vue&type=script&lang=js"
export * from "./HomeCirculars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__